import { useState } from 'react';

import { useCloudAssetIntegrationsQuery } from '@oneclick/hooks/queries/inventory';

type UseBaselineIntegrationIdsArgs = {
  shouldCapture: boolean;
};

/**
 * Captures cloud asset integration IDs before the connect script runs, so the
 * connecting step can detect the new integration (not immediately in the API).
 * Keep shouldCapture true through setup and connecting until a baseline exists;
 * the first settled list (including empty) is frozen for the rest of the dialog.
 */
export const useBaselineIntegrationIds = ({
  shouldCapture,
}: UseBaselineIntegrationIdsArgs): Set<string> | null => {
  const [baseline, setBaseline] = useState<Set<string> | null>(null);

  const {
    data: integrations,
    isSuccess,
    isFetching,
  } = useCloudAssetIntegrationsQuery({
    enabled: shouldCapture && baseline === null,
  });

  if (
    baseline === null &&
    isSuccess &&
    !isFetching &&
    integrations !== undefined
  ) {
    setBaseline(
      new Set(
        integrations
          .map((integration) => integration.id)
          .filter((id): id is string => Boolean(id))
      )
    );
  }

  return baseline;
};
